import { useQuery } from "react-query";
import { TransactionService } from "./transaction.service";

export const useTransactions = (page: number, option?: Object) => {
  return useQuery(
    ["list_transaction", page, option],
    async () => {
      const { data } = await TransactionService.getAll({ page, ...option });
      return data;
    },
    { keepPreviousData: true },
  );
};
